import styled from 'styled-components';
import { motion } from 'framer-motion';

export const Logo = styled(motion.img)``;
